// extracted by mini-css-extract-plugin
module.exports = {"fontSetting":"index-module--font-setting--3cdaq","fontColor":"index-module--font-color--TG6_7"};